module.exports = __webpack_public_path__ + "img/video.ff5f593f.svg";